import { useEffect } from 'react';
import { useFormikContext } from 'formik';

const isObject = obj => typeof obj === 'object' && obj !== null;

const getFirstErrorKey = (object, keys = []) => {
    const firstErrorKey = Object.keys(object)[0];

    if (isObject(object[firstErrorKey])) {
        return getFirstErrorKey(object[firstErrorKey], [...keys, firstErrorKey]);
    }
    return [...keys, firstErrorKey].join('.');
};
// https://github.com/formium/formik/issues/146#issuecomment-728114639
const ScrollToError = ({ children }) => {
    const formik = useFormikContext();

    useEffect(() => {
        if (!formik.isValid && formik.submitCount > 0) {
            const firstErrorKey = getFirstErrorKey(formik.errors);
            const input = global.window.document.getElementsByName(firstErrorKey);
            if (input.length) {
                input[0].focus();
                input[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    alignToTop: true,
                });
                // handle selects with hidden inputs
                if (input[0].getAttribute('type') === 'hidden') {
                    input[0].parentElement.parentElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.submitCount]);
    return children;
};

export default ScrollToError;
